import React from 'react'
import { connect } from 'react-redux'


const NCartLoadingProduct  = props => {
    const no_img = "https://www.tdpra.ru/static/shop_backbone/images/noimage.png"
    return (
        <div className="row ncart-product blur" key={props.key}>
          <div className="col-md-2">
              <div className="ncart-checked-button">
                  <input type="checkbox" className="ncart-checkbox filled-in"/>
                  <label></label>
              </div>
              <div className="ncart-image">
                  <a href="#">
                      <img className="img-responsive" src={no_img}/>
                  </a>
              </div>
          </div>

          <div className="col-md-7">
              <h4 className="ncart-item-heading">
                  <span className="ncart-art-heading">Артикул: </span> <span>D32239</span>
              </h4>
              <h4 className="ncart-item-title">
                  <a href="#"> Наименование загружаемого товара</a>
              </h4>
              <div className="ncart-item-description">
                  <strong>Размер:</strong> 300х820х508 <br/>
                  <strong>Комплектация:</strong> фасадами C доводчиками <br/>
                  <strong>Материалы:</strong> ЛДСП Бук светлый 166/1 3500*1750*16 (Д)
              </div>
          </div>

          <div className="col-md-3">

              <div className="ncart-extra-price">
                  <span className="ncart-extra-price-padding">
                      &nbsp;
                  </span>

                      <span>1299&nbsp;&#8381;</span>

                <span className="delete-control">
                      <i className="material-icons">close</i>
                  </span>
              </div>

              <div className="ncart-item-price">
                  <span className="price">1100&nbsp;&#8381;</span>
              </div>
              <div className="ncart-item-quantity">

                      <div className="nquantity-control nquantity-down disabled">
                        <i className="material-icons">remove</i>
                      </div>

                      <div className="ncart-form-line">
                          <input type="text" className="ncart-form-control disabled" value="3" readOnly={true}/>
                      </div>

                      <div className="nquantity-control nquantity-up disabled">
                          <i className="material-icons">add</i>
                      </div>
              </div>
              <div className="ncart-item-unit">шт.</div>
          </div>
      </div>
)}

const mapStateToProps = state => ({})

export default connect(
    mapStateToProps,
)(NCartLoadingProduct)
